module.exports = __webpack_public_path__ + "static/img/newsbanner.4952899.png";


//////////////////
// WEBPACK FOOTER
// ./public/newsImg/newsbanner.png
// module id = jBK2
// module chunks = 0